import cn from 'classnames'
import { useEffect, useState } from 'react'
import './index.css'
import {IcoRemove} from "@pages/Admin/constsIcon";
import classNames from 'classnames';

let bodyScrollLockCount = 0
let previousBodyOverflow = ''

const lockBodyScroll = () => {
  if (bodyScrollLockCount === 0) {
    previousBodyOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
  }
  bodyScrollLockCount += 1
}

const unlockBodyScroll = () => {
  bodyScrollLockCount = Math.max(0, bodyScrollLockCount - 1)
  if (bodyScrollLockCount === 0) {
    document.body.style.overflow = previousBodyOverflow
  }
}

const Modal = ({ setActive, active = false, className = false, classNameBackground = '', fullScreenMobile = true, disableBackdropDismiss = false, children, styleContent = {}, style = {zIndex: '103'} }) => {
  const [isMounted, setIsMounted] = useState(false)

   useEffect(() => {
    if (!active) return

    lockBodyScroll()
    return unlockBodyScroll
  }, [active])

  useEffect(() => {
    active ? setIsMounted(true) : setIsMounted(false)
  }, [active])

  const closeOnBackdrop = (event) => {
    if (disableBackdropDismiss || event.target !== event.currentTarget) {
      return
    }
    setActive(false)
  }

  return <div style={style} className={cn('modal__background', { 'active': active && isMounted }, {[classNameBackground]: classNameBackground})} onMouseDown={closeOnBackdrop} onTouchStart={closeOnBackdrop} >
    <div className={cn('modal__content', { [className]: className }, { 'fullScreenMobile': fullScreenMobile })} style={styleContent} onMouseDown={e => e.stopPropagation()} onTouchStart={e => e.stopPropagation()}>
      {active && children}
    </div>
  </div>
}


export default Modal

export const ModalContainer = ({ children, closeModal, className='', closeDisabled = false }) => {
  return(
      <div className={classNames('modalContainerWrapper', {[className]: !!className})}>
          {!closeDisabled && <IcoRemove className='modalProfileIconClose' onClick={closeModal}/>}
          {children}
      </div>
  )
}
